package com.schoolconnect.app.feature.studentenrollment

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInputBorder
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppPurpleSoft
import com.schoolconnect.app.designsystem.AppPurpleText
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSoftSurface
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetCell
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetGridOverlay
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetRow
import com.schoolconnect.app.designsystem.list.AdminListPagination
import com.schoolconnect.app.designsystem.list.AdminListRowsPerPageButton
import com.schoolconnect.app.designsystem.list.AdminListScrollableTableCard
import com.schoolconnect.app.feature.imports.ImportReviewTabs
import com.schoolconnect.app.feature.imports.ImportTabUiModel
import com.schoolconnect.app.feature.common.ShellPageHeader
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.arrow_left
import ischoolconnect.sharedui.generated.resources.arrow_right
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.clipboard_check
import ischoolconnect.sharedui.generated.resources.cloud_upload
import ischoolconnect.sharedui.generated.resources.database_download
import ischoolconnect.sharedui.generated.resources.download
import ischoolconnect.sharedui.generated.resources.file_xlsx
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.records_list
import ischoolconnect.sharedui.generated.resources.calendar
import org.jetbrains.compose.resources.painterResource

internal val StudentEnrollmentBackground = AppSecondaryBackground
internal val StudentEnrollmentSurface = AppSurface
internal val StudentEnrollmentBorder = AppBorder
internal val StudentEnrollmentLine = AppLine
internal val StudentEnrollmentNavy = AppNavy
internal val StudentEnrollmentMuted = AppMuted
internal val StudentEnrollmentPrimary = AppPrimary
internal val StudentEnrollmentPrimaryHover = Color(0xFF084BE0)
internal val StudentEnrollmentSuccess = AppSuccess
internal val StudentEnrollmentSuccessBg = AppSuccessSoft
internal val StudentEnrollmentDanger = AppDanger
internal val StudentEnrollmentDangerBg = AppDangerSoft
internal val StudentEnrollmentPurple = AppPurpleText
internal val StudentEnrollmentPurpleBg = AppPurpleSoft
internal val StudentEnrollmentSoftSurface = AppSoftSurface
internal val StudentEnrollmentMaleBg = AppPrimarySoft
internal val StudentEnrollmentMaleText = AppPrimary
internal val StudentEnrollmentFemaleBg = AppPurpleSoft
internal val StudentEnrollmentFemaleText = AppPurpleText

private val StudentEnrollmentHeaderShape = RoundedCornerShape(8.dp)
private val StudentEnrollmentCardShape = RoundedCornerShape(8.dp)
private val StudentEnrollmentFooterButtonHeight = 50.dp
private val StudentEnrollmentFooterButtonWidth = 280.dp
private val StudentEnrollmentStudentsTableMinWidth = 1360.dp
private val StudentEnrollmentParentsTableMinWidth = 1720.dp

@Composable
fun StudentEnrollmentPageHeader(
    title: String,
    subtitle: String,
    detailText: String? = null,
    headerActions: @Composable RowScope.() -> Unit = {},
    modifier: Modifier = Modifier
) {
    ShellPageHeader(
        title = title,
        subtitle = subtitle,
        detailText = detailText,
        modifier = modifier,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        detailColor = StudentEnrollmentMuted,
        headerActions = headerActions
    )
}

@Composable
fun StudentEnrollmentBackButton(
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    StudentEnrollmentOutlineButton(
        label = label,
        icon = painterResource(Res.drawable.arrow_left),
        onClick = onClick,
        modifier = modifier,
        borderColor = StudentEnrollmentBorder,
        contentColor = StudentEnrollmentPrimary,
        height = StudentEnrollmentFooterButtonHeight,
        horizontalPadding = 22.dp
    )
}

@Composable
internal fun StudentEnrollmentOutlineButton(
    label: String,
    icon: Painter? = null,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    borderColor: Color,
    contentColor: Color,
    backgroundColor: Color = StudentEnrollmentSurface,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 16.dp
) {
    Surface(
        modifier = modifier
            .height(height)
            .clickable(onClick = onClick),
        shape = RoundedCornerShape(8.dp),
        color = backgroundColor,
        border = BorderStroke(1.dp, borderColor)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = horizontalPadding),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            if (icon != null) {
                Icon(painter = icon, contentDescription = null, tint = contentColor)
                Spacer(modifier = Modifier.width(8.dp))
            }
            Text(
                text = label,
                color = contentColor,
                fontWeight = FontWeight.SemiBold,
                fontSize = 14.sp,
                maxLines = 1,
                softWrap = false,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
internal fun StudentEnrollmentFilledButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    backgroundColor: Color = StudentEnrollmentPrimary,
    contentColor: Color = Color.White,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 18.dp,
    enabled: Boolean = true
) {
    Surface(
        modifier = modifier
            .height(height)
            .clickable(enabled = enabled, onClick = onClick),
        shape = RoundedCornerShape(8.dp),
        color = if (enabled) backgroundColor else backgroundColor.copy(alpha = 0.5f)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = horizontalPadding),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            Icon(
                painter = icon,
                contentDescription = null,
                tint = if (enabled) contentColor else contentColor.copy(alpha = 0.7f)
            )
            Spacer(modifier = Modifier.width(8.dp))
            Text(
                text = label,
                color = if (enabled) contentColor else contentColor.copy(alpha = 0.7f),
                fontWeight = FontWeight.SemiBold,
                fontSize = 14.sp,
                maxLines = 1,
                softWrap = false,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
fun StudentEnrollmentStepper(
    steps: List<StudentEnrollmentStepUiModel>,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = StudentEnrollmentSurface),
        border = BorderStroke(1.dp, StudentEnrollmentBorder)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 14.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            steps.forEachIndexed { index, step ->
                StudentEnrollmentStepItem(
                    step = step,
                    modifier = Modifier.weight(1f)
                )
                if (index != steps.lastIndex) {
                    Box(
                        modifier = Modifier
                            .weight(2.5f)
                            .height(2.dp)
                            .background(
                                if (step.isCompleted || step.isActive) StudentEnrollmentPrimary else StudentEnrollmentLine
                            )
                    )
                }
            }
        }
    }
}

@Composable
private fun StudentEnrollmentStepItem(
    step: StudentEnrollmentStepUiModel,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Box(
            modifier = Modifier
                .size(44.dp)
                .background(
                    when {
                        step.isCompleted -> StudentEnrollmentSuccess
                        step.isActive -> StudentEnrollmentPrimary
                        else -> Color(0xFFE5EAF4)
                    },
                    CircleShape
                ),
            contentAlignment = Alignment.Center
        ) {
            Text(
                text = if (step.isCompleted) "✓" else step.number.toString(),
                color = if (step.isCompleted || step.isActive) Color.White else StudentEnrollmentNavy,
                fontWeight = FontWeight.Bold,
                fontSize = 16.sp
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(
                text = step.title,
                color = if (step.isActive || step.isCompleted) StudentEnrollmentNavy else StudentEnrollmentMuted,
                fontWeight = FontWeight.ExtraBold,
                style = MaterialTheme.typography.titleMedium
            )
            Text(
                text = step.subtitle,
                color = StudentEnrollmentNavy,
                fontWeight = FontWeight.Medium,
                style = MaterialTheme.typography.bodyMedium
            )
        }
    }
}

@Composable
fun StudentEnrollmentSectionCard(
    title: String,
    subtitle: String,
    icon: Painter,
    stepNumber: Int,
    accent: Color,
    accentSoft: Color,
    content: @Composable () -> Unit
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = StudentEnrollmentHeaderShape,
        colors = CardDefaults.cardColors(containerColor = StudentEnrollmentSurface),
        border = BorderStroke(1.dp, StudentEnrollmentBorder)
    ) {
        Column(
            modifier = Modifier.padding(horizontal = 22.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(14.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .size(30.dp)
                        .background(StudentEnrollmentSoftSurface, StudentEnrollmentHeaderShape),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = stepNumber.toString(),
                        color = StudentEnrollmentPrimary,
                        fontWeight = FontWeight.ExtraBold
                    )
                }
                Box(
                    modifier = Modifier
                        .size(54.dp)
                        .background(accentSoft, CircleShape),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = icon,
                        contentDescription = title,
                        tint = accent,
                        modifier = Modifier.size(26.dp)
                    )
                }
                Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                    Text(
                        text = title,
                        style = MaterialTheme.typography.titleMedium,
                        fontSize = 18.sp,
                        fontWeight = FontWeight.ExtraBold,
                        color = StudentEnrollmentNavy
                    )
                    Text(
                        text = subtitle,
                        style = MaterialTheme.typography.bodyMedium,
                        fontSize = 14.sp,
                        color = StudentEnrollmentMuted
                    )
                }
            }
            content()
        }
    }
}

@Composable
fun StudentEnrollmentSummaryGrid(
    rows: List<StudentEnrollmentSummaryRow>,
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(14.dp)) {
        rows.forEach { row ->
            StudentEnrollmentSummaryRowView(row = row)
        }
    }
}

@Composable
private fun StudentEnrollmentSummaryRowView(
    row: StudentEnrollmentSummaryRow
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = row.label,
            style = MaterialTheme.typography.bodyLarge,
            fontWeight = FontWeight.Medium,
            color = StudentEnrollmentNavy
        )
        if (row.badgeText != null) {
            Box(
                modifier = Modifier
                    .background(row.badgeBackground, RoundedCornerShape(8.dp))
                    .padding(horizontal = 10.dp, vertical = 4.dp)
            ) {
                Text(
                    text = row.badgeText,
                    color = row.badgeColor,
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.labelLarge
                )
            }
        } else {
            Text(
                text = row.value,
                style = MaterialTheme.typography.bodyLarge,
                fontWeight = FontWeight.Bold,
                color = row.valueColor
            )
        }
    }
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(1.dp)
            .background(StudentEnrollmentLine)
    )
}

@Composable
fun StudentEnrollmentActionFooter(
    onCancel: () -> Unit,
    primaryLabel: String,
    primaryIcon: Painter,
    primaryEnabled: Boolean = true,
    onPrimaryClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(16.dp, Alignment.End),
        verticalAlignment = Alignment.CenterVertically
    ) {
        StudentEnrollmentOutlineButton(
            label = "Cancel",
            onClick = onCancel,
            borderColor = StudentEnrollmentBorder,
            contentColor = StudentEnrollmentNavy,
            modifier = Modifier.width(StudentEnrollmentFooterButtonWidth)
        )
        StudentEnrollmentFilledButton(
            label = primaryLabel,
            icon = primaryIcon,
            onClick = onPrimaryClick,
            modifier = Modifier.width(StudentEnrollmentFooterButtonWidth),
            backgroundColor = StudentEnrollmentPrimary,
            contentColor = Color.White,
            enabled = primaryEnabled
        )
    }
}

@Composable
fun StudentEnrollmentSummaryStrip(
    summary: StudentEnrollmentReviewSummary,
    modifier: Modifier = Modifier
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        color = StudentEnrollmentSoftSurface,
        border = BorderStroke(1.dp, StudentEnrollmentBorder)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 20.dp, vertical = 16.dp),
            horizontalArrangement = Arrangement.spacedBy(24.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            StudentEnrollmentSummaryItem("File:", summary.fileName, painterResource(Res.drawable.file_xlsx))
            DividerLine()
            StudentEnrollmentSummaryItem("Selected On:", summary.uploadedOn, painterResource(Res.drawable.calendar))
            DividerLine()
            StudentEnrollmentSummaryItem("Ready to Save:", "${summary.readyToSaveRows} rows", painterResource(Res.drawable.records_list))
            DividerLine()
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                Box(
                    modifier = Modifier
                        .size(28.dp)
                        .background(StudentEnrollmentSuccess, CircleShape),
                    contentAlignment = Alignment.Center
                ) {
                    Text(text = "✓", color = Color.White, fontWeight = FontWeight.Bold)
                }
                Text(
                    text = "Status:",
                    color = StudentEnrollmentNavy,
                    fontWeight = FontWeight.Bold
                )
                Text(
                    text = summary.status,
                    color = StudentEnrollmentSuccess,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}

@Composable
private fun StudentEnrollmentSummaryItem(
    label: String,
    value: String,
    icon: Painter
) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
        Icon(painter = icon, contentDescription = null, tint = StudentEnrollmentPrimary)
        Text(text = label, color = StudentEnrollmentNavy, fontWeight = FontWeight.Bold)
        Text(text = value, color = StudentEnrollmentNavy, fontWeight = FontWeight.ExtraBold)
    }
}

@Composable
private fun DividerLine() {
    Box(
        modifier = Modifier
            .width(1.dp)
            .height(28.dp)
            .background(StudentEnrollmentBorder)
    )
}

@Composable
fun StudentEnrollmentSheetToolbar(
    selectedSheet: String,
    sheetOptions: List<String>,
    onSheetSelected: (String) -> Unit,
    onFilterClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.End,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box {
            StudentEnrollmentOutlineButton(
                label = selectedSheet,
                icon = painterResource(Res.drawable.chevron_down),
                onClick = { expanded = true },
                borderColor = StudentEnrollmentBorder,
                contentColor = StudentEnrollmentPrimary,
                modifier = Modifier.width(140.dp)
            )
            AppDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false }
            ) {
                sheetOptions.forEach { option ->
                    DropdownMenuItem(
                        text = { Text(option) },
                        onClick = {
                            onSheetSelected(option)
                            expanded = false
                        }
                    )
                }
            }
        }
        Spacer(modifier = Modifier.width(14.dp))
        StudentEnrollmentOutlineButton(
            label = "Filters",
            icon = painterResource(Res.drawable.filter),
            onClick = onFilterClick,
            borderColor = StudentEnrollmentBorder,
            contentColor = StudentEnrollmentNavy,
            modifier = Modifier.width(128.dp)
        )
    }
}

@Composable
fun StudentEnrollmentTabRow(
    tabs: List<StudentEnrollmentTabUiModel>,
    onTabSelected: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        val selectedTabId = tabs.firstOrNull { it.isSelected }?.id ?: tabs.firstOrNull()?.id.orEmpty()
        Box(
            modifier = Modifier
                .weight(1f)
                .horizontalScroll(rememberScrollState())
        ) {
            ImportReviewTabs(
                tabs = tabs.map { tab ->
                    ImportTabUiModel(
                        id = tab.id,
                        title = tab.title,
                        count = tab.count,
                        isSelected = tab.isSelected
                    )
                },
                selectedTabId = selectedTabId,
                onTabSelected = onTabSelected,
                modifier = Modifier
            )
        }
    }
}

@Composable
internal fun StudentEnrollmentRowsPerPageSelector(
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit
) {
    var expanded by androidx.compose.runtime.remember { androidx.compose.runtime.mutableStateOf(false) }
    Box {
        AdminListRowsPerPageButton(
            pageSize = rowsPerPage,
            expanded = expanded,
            onClick = { expanded = true },
            borderColor = StudentEnrollmentBorder,
            surfaceColor = StudentEnrollmentSurface,
            contentColor = StudentEnrollmentNavy,
            iconTint = StudentEnrollmentMuted
        )
        AppDropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false }
        ) {
            com.schoolconnect.app.feature.common.PaginationPolicy.PAGE_SIZE_OPTIONS.forEach { option ->
                DropdownMenuItem(
                    text = { Text("$option") },
                    onClick = {
                        onRowsPerPageChanged(option)
                        expanded = false
                    }
                )
            }
        }
    }
}

@Composable
fun StudentEnrollmentErrorTable(
    errorRows: List<StudentEnrollmentErrorRow>,
    pageIndex: Int,
    pageCount: Int,
    pageText: String,
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit,
    onDownloadErrors: () -> Unit,
    onFilterClick: () -> Unit,
    selectedSheet: String,
    sheetOptions: List<String>,
    onSheetSelected: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    val visibleRows = errorRows.drop(pageIndex.coerceAtLeast(0) * safeRowsPerPage).take(safeRowsPerPage)
    Column(modifier = modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
        StudentEnrollmentSheetToolbar(
            selectedSheet = selectedSheet,
            sheetOptions = sheetOptions,
            onSheetSelected = onSheetSelected,
            onFilterClick = onFilterClick
        )
        StudentEnrollmentTableCard(
            title = "Errors Found (${errorRows.size})",
            subtitle = "Only rows with errors are shown below.",
            headerColumns = listOf(
                AdminListHeaderColumn("Sheet Name", 0.24f),
                AdminListHeaderColumn("Row No.", 0.15f),
                AdminListHeaderColumn("Status", 0.14f),
                AdminListHeaderColumn("Error Message", 0.47f)
            ),
            rows = visibleRows.map { row ->
                listOf(row.sheetName, row.rowNo, "Error", row.message)
            },
            pageText = pageText,
            pageIndex = pageIndex,
            pageCount = pageCount,
            rowsPerPage = safeRowsPerPage,
            onRowsPerPageChanged = onRowsPerPageChanged,
            onPageChanged = onPageChanged,
            onDownload = onDownloadErrors
        )
    }
}

@Composable
fun StudentEnrollmentStudentTable(
    records: List<StudentEnrollmentStudentRecordUiModel>,
    pageIndex: Int,
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit,
    pageText: String? = null,
    pageCount: Int? = null,
    modifier: Modifier = Modifier
) {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    val visibleRows = records.drop(pageIndex.coerceAtLeast(0) * safeRowsPerPage).take(safeRowsPerPage)
    StudentEnrollmentStudentTableCard(
        modifier = modifier,
        title = "Students",
        subtitle = null,
        rows = visibleRows,
        headerColumns = listOf(
            AdminListHeaderColumn("Row No.", 0.07f),
            AdminListHeaderColumn("Admission No.", 0.12f),
            AdminListHeaderColumn("Class", 0.07f),
            AdminListHeaderColumn("Section", 0.07f),
            AdminListHeaderColumn("Student Name", 0.17f),
            AdminListHeaderColumn("Roll No.", 0.08f),
            AdminListHeaderColumn("Gender", 0.08f),
            AdminListHeaderColumn("DOB", 0.10f),
            AdminListHeaderColumn("Subject Codes", 0.19f),
            AdminListHeaderColumn("Blood Group", 0.08f)
        ),
        pageText = pageText
            ?: "Showing ${if (records.isEmpty()) 0 else pageIndex * safeRowsPerPage + 1} to ${minOf((pageIndex + 1) * safeRowsPerPage, records.size)} of ${records.size} records",
        pageIndex = pageIndex,
        pageCount = pageCount ?: maxOf(1, (records.size + safeRowsPerPage - 1) / safeRowsPerPage),
        rowsPerPage = safeRowsPerPage,
        onRowsPerPageChanged = onRowsPerPageChanged,
        onPageChanged = onPageChanged
    )
}

@Composable
fun StudentEnrollmentParentTable(
    records: List<StudentEnrollmentParentRecordUiModel>,
    pageIndex: Int,
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit,
    pageText: String? = null,
    pageCount: Int? = null,
    modifier: Modifier = Modifier
) {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    val visibleRows = records.drop(pageIndex.coerceAtLeast(0) * safeRowsPerPage).take(safeRowsPerPage)
    StudentEnrollmentTableCard(
        modifier = modifier,
        title = "Parents",
        subtitle = null,
        headerColumns = listOf(
            AdminListHeaderColumn("Row No.", 0.07f),
            AdminListHeaderColumn("Admission No.", 0.12f),
            AdminListHeaderColumn("Primary Contact Name", 0.16f),
            AdminListHeaderColumn("Primary Contact Mobile", 0.13f),
            AdminListHeaderColumn("Primary Contact Email", 0.17f),
            AdminListHeaderColumn("Primary Contact Relationship", 0.11f),
            AdminListHeaderColumn("Secondary Contact Name", 0.16f),
            AdminListHeaderColumn("Secondary Contact Mobile", 0.13f),
            AdminListHeaderColumn("Secondary Contact Email", 0.17f),
            AdminListHeaderColumn("Secondary Contact Relationship", 0.11f)
        ),
        rows = visibleRows.map { row ->
            listOf(
                row.rowNo.toString(),
                row.admissionNo,
                row.primaryContactName,
                row.primaryContactMobile,
                row.primaryContactEmail,
                row.primaryContactRelationship,
                row.secondaryContactName,
                row.secondaryContactMobile,
                row.secondaryContactEmail,
                row.secondaryContactRelationship
            )
        },
        pageText = pageText
            ?: "Showing ${if (records.isEmpty()) 0 else pageIndex * safeRowsPerPage + 1} to ${minOf((pageIndex + 1) * safeRowsPerPage, records.size)} of ${records.size} records",
        pageIndex = pageIndex,
        pageCount = pageCount ?: maxOf(1, (records.size + safeRowsPerPage - 1) / safeRowsPerPage),
        rowsPerPage = safeRowsPerPage,
        onRowsPerPageChanged = onRowsPerPageChanged,
        onPageChanged = onPageChanged,
        showRowsPerPageSelector = true,
    )
}

@Composable
private fun StudentEnrollmentTableCard(
    title: String,
    subtitle: String? = null,
    headerColumns: List<AdminListHeaderColumn>,
    rows: List<List<String>>,
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit,
    onDownload: (() -> Unit)? = null,
    showRowsPerPageSelector: Boolean = true,
    modifier: Modifier = Modifier
) {
    AdminListScrollableTableCard(
        minContentWidth = StudentEnrollmentParentsTableMinWidth,
        modifier = modifier.fillMaxWidth(),
        surfaceColor = StudentEnrollmentSurface,
        borderColor = StudentEnrollmentBorder,
        header = {
            Column(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 22.dp, vertical = 16.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                        Text(
                            text = title,
                            color = StudentEnrollmentNavy,
                            fontWeight = FontWeight.ExtraBold,
                            style = MaterialTheme.typography.titleLarge
                        )
                        if (!subtitle.isNullOrBlank()) {
                            Text(
                                text = subtitle,
                                color = StudentEnrollmentMuted,
                                fontWeight = FontWeight.Medium,
                                style = MaterialTheme.typography.bodyMedium
                            )
                        }
                    }
                    if (onDownload != null) {
                        StudentEnrollmentOutlineButton(
                            label = "Download Error Details",
                            icon = painterResource(Res.drawable.download),
                            onClick = onDownload,
                            borderColor = StudentEnrollmentBorder,
                            contentColor = StudentEnrollmentPrimary
                        )
                    }
                }
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.dp)
                        .background(StudentEnrollmentBorder)
                )
            }
        },
        body = {
            BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
                Column(modifier = Modifier.fillMaxSize()) {
                    AdminListSpreadsheetHeaderRow(
                        columns = headerColumns,
                        labelColor = StudentEnrollmentNavy,
                        horizontalPadding = 22.dp,
                        dividerWidth = 1.5.dp,
                        showVerticalDividers = false
                    )
                    HorizontalDivider(color = StudentEnrollmentBorder)
                    if (rows.isEmpty()) {
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = "No records to display",
                                color = StudentEnrollmentMuted,
                                fontWeight = FontWeight.Medium
                            )
                        }
                    } else {
                        LazyColumn(modifier = Modifier.fillMaxSize()) {
                            items(rows) { rowValues ->
                                AdminListSpreadsheetRow(
                                    cells = rowValues.mapIndexed { index, value ->
                                        AdminListSpreadsheetCell(
                                            weight = headerColumns.getOrNull(index)?.weight ?: 1f
                                        ) {
                                            StudentEnrollmentCell(text = value)
                                        }
                                    },
                                    height = 44.dp,
                                    horizontalPadding = 22.dp,
                                    dividerWidth = 1.5.dp,
                                    showVerticalDividers = false,
                                    backgroundColor = StudentEnrollmentSurface,
                                    dividerColor = StudentEnrollmentBorder
                                )
                                HorizontalDivider(color = StudentEnrollmentBorder)
                            }
                        }
                    }
                }
                AdminListSpreadsheetGridOverlay(
                    weights = headerColumns.map { it.weight },
                    modifier = Modifier.fillMaxSize(),
                    horizontalPadding = 22.dp,
                    dividerWidth = 1.5.dp,
                    dividerColor = StudentEnrollmentBorder
                )
            }
        },
        footer = {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 22.dp, vertical = 14.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (onDownload != null) {
                    StudentEnrollmentOutlineButton(
                        label = "Download Error Details",
                        icon = painterResource(Res.drawable.download),
                        onClick = onDownload,
                        borderColor = StudentEnrollmentBorder,
                        contentColor = StudentEnrollmentPrimary
                    )
                } else {
                    Spacer(modifier = Modifier.width(1.dp))
                }
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                    Text(
                        text = pageText,
                        color = StudentEnrollmentNavy,
                        fontWeight = FontWeight.Medium
                    )
                    AdminListPagination(
                        pageIndex = pageIndex,
                        pageCount = pageCount,
                        onPageChanged = onPageChanged,
                        borderColor = StudentEnrollmentBorder,
                        surfaceColor = StudentEnrollmentSurface,
                        primaryColor = StudentEnrollmentPrimary,
                        navyColor = StudentEnrollmentNavy,
                        mutedColor = StudentEnrollmentMuted
                    )
                    StudentEnrollmentRowsPerPageSelector(
                        rowsPerPage = rowsPerPage,
                        onRowsPerPageChanged = onRowsPerPageChanged
                    )
                }
            }
        }
    )
}

@Composable
private fun StudentEnrollmentStudentTableCard(
    title: String,
    subtitle: String? = null,
    headerColumns: List<AdminListHeaderColumn>,
    rows: List<StudentEnrollmentStudentRecordUiModel>,
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit,
    onPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    AdminListScrollableTableCard(
        minContentWidth = StudentEnrollmentStudentsTableMinWidth,
        modifier = modifier.fillMaxWidth(),
        surfaceColor = StudentEnrollmentSurface,
        borderColor = StudentEnrollmentBorder,
        header = {
            Column(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 22.dp, vertical = 16.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                        Text(
                            text = title,
                            color = StudentEnrollmentNavy,
                            fontWeight = FontWeight.ExtraBold,
                            style = MaterialTheme.typography.titleLarge
                        )
                        if (!subtitle.isNullOrBlank()) {
                            Text(
                                text = subtitle,
                                color = StudentEnrollmentMuted,
                                fontWeight = FontWeight.Medium,
                                style = MaterialTheme.typography.bodyMedium
                            )
                        }
                    }
                }
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.dp)
                        .background(StudentEnrollmentBorder)
                )
            }
        },
        body = {
            BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
                Column(modifier = Modifier.fillMaxSize()) {
                    AdminListSpreadsheetHeaderRow(
                        columns = headerColumns,
                        labelColor = StudentEnrollmentNavy,
                        horizontalPadding = 22.dp,
                        dividerWidth = 1.5.dp,
                        showVerticalDividers = false
                    )
                    HorizontalDivider(color = StudentEnrollmentBorder)
                    if (rows.isEmpty()) {
                        Box(
                            modifier = Modifier.fillMaxSize(),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = "No records to display",
                                color = StudentEnrollmentMuted,
                                fontWeight = FontWeight.Medium
                            )
                        }
                    } else {
                        LazyColumn(modifier = Modifier.fillMaxSize()) {
                            items(rows) { row ->
                                StudentEnrollmentStudentRow(row = row, headerColumns = headerColumns)
                                HorizontalDivider(color = StudentEnrollmentBorder)
                            }
                        }
                    }
                }
                AdminListSpreadsheetGridOverlay(
                    weights = headerColumns.map { it.weight },
                    modifier = Modifier.fillMaxSize(),
                    horizontalPadding = 22.dp,
                    dividerWidth = 1.5.dp,
                    dividerColor = StudentEnrollmentBorder
                )
            }
        },
        footer = {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 22.dp, vertical = 14.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Spacer(modifier = Modifier.width(1.dp))
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                    Text(
                        text = pageText,
                        color = StudentEnrollmentNavy,
                        fontWeight = FontWeight.Medium
                    )
                    AdminListPagination(
                        pageIndex = pageIndex,
                        pageCount = pageCount,
                        onPageChanged = onPageChanged,
                        borderColor = StudentEnrollmentBorder,
                        surfaceColor = StudentEnrollmentSurface,
                        primaryColor = StudentEnrollmentPrimary,
                        navyColor = StudentEnrollmentNavy,
                        mutedColor = StudentEnrollmentMuted
                    )
                    StudentEnrollmentRowsPerPageSelector(
                        rowsPerPage = rowsPerPage,
                        onRowsPerPageChanged = onRowsPerPageChanged
                    )
                }
            }
        }
    )
}

@Composable
private fun StudentEnrollmentStudentRow(
    row: StudentEnrollmentStudentRecordUiModel,
    headerColumns: List<AdminListHeaderColumn>
) {
        AdminListSpreadsheetRow(
            cells = listOf(
            AdminListSpreadsheetCell(headerColumns.getOrNull(0)?.weight ?: 0.07f) { StudentEnrollmentCell(text = row.rowNo.toString()) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(1)?.weight ?: 0.12f) { StudentEnrollmentCell(text = row.admissionNo) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(2)?.weight ?: 0.07f) { StudentEnrollmentCell(text = row.className) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(3)?.weight ?: 0.07f) { StudentEnrollmentCell(text = row.section) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(4)?.weight ?: 0.17f) { StudentEnrollmentCell(text = row.studentName) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(5)?.weight ?: 0.08f) { StudentEnrollmentCell(text = row.rollNo) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(6)?.weight ?: 0.08f) { StudentEnrollmentCell(text = row.gender) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(7)?.weight ?: 0.10f) { StudentEnrollmentCell(text = row.dob) },
            AdminListSpreadsheetCell(headerColumns.getOrNull(8)?.weight ?: 0.19f) {
                StudentEnrollmentSubjectChipsCell(chips = row.subjectCodes, modifier = Modifier.fillMaxWidth())
            },
            AdminListSpreadsheetCell(headerColumns.getOrNull(9)?.weight ?: 0.08f) { StudentEnrollmentCell(text = row.bloodGroup) }
        ),
        height = null,
        minHeight = 56.dp,
        horizontalPadding = 22.dp,
        dividerWidth = 1.5.dp,
        showVerticalDividers = false,
        backgroundColor = StudentEnrollmentSurface,
        dividerColor = StudentEnrollmentBorder
    )
}

@Composable
private fun StudentEnrollmentCell(
    text: String,
    modifier: Modifier = Modifier
) {
    Text(
        text = text,
        color = StudentEnrollmentNavy,
        fontWeight = FontWeight.Medium,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = modifier
    )
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun StudentEnrollmentSubjectChipsCell(
    chips: List<StudentEnrollmentSubjectChipUiModel>,
    modifier: Modifier = Modifier
) {
    FlowRow(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        chips.forEach { chip ->
            Surface(
                color = chip.background,
                shape = RoundedCornerShape(6.dp)
            ) {
                Text(
                    text = chip.label,
                    color = chip.contentColor,
                    fontWeight = FontWeight.Bold,
                    fontSize = 12.sp,
                    maxLines = 1,
                    softWrap = false,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.padding(horizontal = 10.dp, vertical = 4.dp)
                )
            }
        }
    }
}
